module.exports = __webpack_public_path__ + "static/img/l3.369caa5f.png";